<template>
    <v-container class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-sm-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">MIS TICKETS
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getClaims">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-btn color="primary" large block to="/user/support/new">
                            <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;Crear ticket
                        </v-btn>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps">
                        <template v-slot:item.id="{ item }">
                            <strong>{{ item.id }}</strong>
                        </template>
                        <template v-slot:item.module="{ item }">
                            <v-chip small label color="secondary" class="primary--text font-weight-bold">{{ moduleLabel(item.pay_form) }}</v-chip>
                        </template>
                        <template v-slot:item.reference="{ item }">
                            {{ referenceText(item) }}
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small label :color="getColor(item.status_id)" :dark="(getColor(item.status_id) !== 'bg')">
                                <strong>{{ item.status }}</strong>
                            </v-chip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" small depressed class="ma-1" title="Detalles" :to="'/user/support/' + item.id">
                                <v-icon>mdi-chat</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Claims",
        props: [ 'user' ],
        data: () => ({
            search: '',
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Area', value: 'module' },
                { text: 'Referencia', value: 'reference' },
                { text: 'Motivo', value: 'reason' },
                { text: 'Estado', value: 'status', align: 'center', sortable: false },
                { text: 'Actualizado', value: 'updated_at' },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false },
            ],
            desserts: [],
            expanded: [],
            loading: true,
            noDataText: 'No tienes tickets',
            expandIcon: 'mdi-chevron-down-circle',
            footerProps: {
                itemsPerPageOptions: [25, 50, 100, 250, -1]
            },
            claim: null
        }),
        created () {
            this.getClaims();
        },
        methods: {
            getClaims(v) {
                clearTimeout(this.timeout);
                if (v === 1) {
                    this.loading = true;
                }
                axios.get('/api/claims').then((res) => {
                    this.desserts = res.data.items || [];
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.handleErrors(err.response.data.errors);
                    } else {
                        this.$toast.error('No fue posible cargar tus tickets.', { icon: 'mdi-alert-circle' });
                    }
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getClaims, 150000);
            },
            getColor(status) {
                if (status === 301) return 'warning';
                if (status === 302) return 'success';
                return 'grey';
            },
            referenceText(item) {
                const id = item.transfer_id || item.payment_id;

                return id ? ('#' + id) : 'Sin referencia';
            },
            moduleLabel(value) {
                const modules = {
                    Wallet: 'Wallet y saldo',
                    Recharge: 'Recarga',
                    Withdrawal: 'Retiro',
                    WalletTransfer: 'Transferencia/QR',
                    Remittance: 'Remesa',
                    BankAccount: 'Cuenta bancaria',
                    Identity: 'Identidad',
                    Rewards: 'Recompensas',
                    App: 'App',
                    Security: 'Seguridad'
                };

                return modules[value] || (value || 'Soporte');
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
